const defer = () => {
  let res;
  let rej;

  const promise = new Promise((resolve, reject) => {
    res = resolve;
    rej = reject;
  });

  return {
    promise,
    resolve: (...args) => res(...args),
    reject: (...args) => rej(...args)
  };
};

export default defer;
